const NAME = 'materialCheckboxes';

import './css/materialCheckboxes.less';

import {MDCFormField} from '@material/form-field';
import {MDCCheckbox} from '@material/checkbox';
import {purgeEls} from '@netx/core/utils/purgeEls';

export default function (target) {
	if (!target || target.hasFunctionality(NAME)) return target;

	target.addInitializer((instance, opts = {}) => {
		let materialCheckboxes = [];

		const cleanUp = () => {
			_.invoke(materialCheckboxes, 'destroy');
			materialCheckboxes = [];
		};

		// Hey, listen!
		instance
			.on('preRenderHook', cleanUp)
			.on('removeHook', cleanUp)
			.on('postRenderHook', () => {
				purgeEls(
					[...instance.el.querySelectorAll('.mdc-form-field')],
					instance.getExcludedViews(),
				).forEach((field) => {
					const checkboxEl = field.querySelector('.mdc-checkbox');
					if (!checkboxEl) return;

					const checkbox = new MDCCheckbox(checkboxEl);
					materialCheckboxes.push(checkbox);

					const formField = new MDCFormField(field);
					formField.input = checkbox;
					materialCheckboxes.push(formField);
				});
			});
	}, NAME);

	return target;
}
